// @flow
import * as React from 'react'

import './Loader.scss'

type Props = {
  collapse?: boolean,
}

export default function Loader(props: Props) {
  const classNameModifier = props.collapse ? 'Loader--collapse' : ''

  return (
    <div className={`Loader ${classNameModifier}`}>
      <div className="Loader-container">
        <div className="Loader-bar" />
        <div className="Loader-bar" />
        <div className="Loader-bar" />
        <div className="Loader-bar" />
      </div>
    </div>
  )
}
